import './Copyright.css'

export const Copyright = () => (<div id='copyright'>
    <p>Copyright © 2023 Renovare Services LLC. All rights reserved.</p>
</div>)